import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    this.contentTargets.forEach(el => el.classList.toggle("hidden"))

    const button = event?.currentTarget
    if (button?.hasAttribute("aria-expanded")) {
      const expanded = button.getAttribute("aria-expanded") === "true"
      button.setAttribute("aria-expanded", String(!expanded))
    }
  }
}
